import axios from 'axios';
import { designShowcaseQuery, designDemoQuery } from './queries';
import { DesignShowcase, DesignDemo } from '@graphql/designShowcaseTypes';

const getUri = (joyEnv: Window['joyEnv']) => {
  if (joyEnv && joyEnv.JOY_CONFIG_SERVICE_HOSTNAME) {
    return `${joyEnv.JOY_CONFIG_SERVICE_PROTOCOL}://${joyEnv.JOY_CONFIG_SERVICE_HOSTNAME}:${
      joyEnv.JOY_CONFIG_SERVICE_PORT
    }/graphql`;
  } else {
    console.error('Environment not found. Falling back to rehearsal.');
    return `https://rehearsal-api.withjoy.com/graphql`;
  }
};

const endpoint = getUri(window.joyEnv);

// const endpoint = 'http://local.withjoy.com:8472/graphql';

class DesignShowcaseApi {
  requestData = async () => {
    try {
      const response = await axios.post<{ data: DesignShowcase; errors?: any[] }>(endpoint, {
        query: designShowcaseQuery
      });

      if (response.data.errors) {
        throw new Error(response.data.errors[0]);
      }

      return response.data.data;
    } catch (e) {
      throw e;
    }
  };

  requestDemoThemes = async () => {
    try {
      const response = await axios.post<{ data: DesignDemo }>(endpoint, {
        query: designDemoQuery
      });
      return response.data.data;
    } catch (e) {
      throw e;
    }
  };
}

export const api = new DesignShowcaseApi();
